<div class="terms mx-auto" style="padding-bottom: 60px">
  <mat-card class="py-4 px-4">
    <h2 class="mb-4 fw-bold">{{ pageContent[0]?.title }}</h2>
    <div [innerHTML]="pageContent[0]?.content"></div>
  </mat-card>
</div>
